import request from '@/utils/request'

// 获取记录
export function getList(data) {
  const { page, size, ...otherData } = data
  const { date, ...otherWhere } = otherData
  const wherePrefix = 'lk_por.'
  const payload = {
    page: {
      current: page,
      size: size
    },
    where: Object.assign({}, ...Object.keys(otherWhere).map((key) => ({ [wherePrefix + key]: `${otherWhere[key] ?? ''}` || undefined })))
  }
  if (date) {
    payload.where["ge_por.createdTime"] = date[0]
    payload.where["le_por.createdTime"] = date[1]

  }
  payload.where["desc_por.createdTime"] = 1
  return request.post('/personOrder/getPage', payload)
}

export function edit(data) {
  if (!data.id) return add(data)
  else return update(data)
}

export function add(data) {
  return request.post('/personOrder/saveRecord', data)
}
export function update(data) {
  return request.post('/personOrder/updateRecord', data)
}

export function del(data) {
  return request.post('/personOrder/deleteBatch', [data.id])
}

export function check(data) {
  const { id, yesOrNo, rejectReason } = data
  return request.get(`/personOrder/check/${id}?yesOrNo=${yesOrNo}&rejectReason=`)
}